import { animate, group, query, style, transition, trigger } from '@angular/animations';

const animationTime = '500ms';

export const expandTdDivsAnimation = trigger('expandTdDivs', [
  transition(
    ':enter',
    [
      group([
        query('td', [
          style({ paddingTop: 0, paddingBottom: 0 }),
          animate('{{duration}} ease-out', style({ paddingTop: '*', paddingBottom: '*' })),
        ]),
        query('td > div', [style({ opacity: 0, height: 0 }), animate('{{duration}} ease-out', style({ opacity: 1, height: '*' }))]),
      ]),
    ],
    { params: { duration: animationTime } },
  ),
  transition(
    ':leave',
    [
      group([
        query('td', [animate('{{duration}} ease-out', style({ paddingTop: 0, paddingBottom: 0 }))]),
        query('td > div', [animate('{{duration}} ease-out', style({ height: 0 }))]),
      ]),
    ],
    { params: { duration: animationTime } },
  ),
]);
